import type { Step } from "react-joyride";

export const documentCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າສ້າງເອກະສານໃໝ່. ຕື່ມລາຍລະອຽດລູກຄ້າ, ລາຍການ ແລະ ບັນທຶກເພື່ອສ້າງລາຄາ ຫຼື ໃບບິນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="document-create-back"]',
    content: "ກັບໄປລາຍການເອກະສານໂດຍບໍ່ບັນທຶກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="document-create-form"]',
    content:
      "ເລືອກປະເພດ (ລາຄາ / ໃບບິນ), ເລືອກລູກຄ້າ ຫຼື ຈັດການລູກຄ້າ, ເພີ່ມລາຍການ ແລະ ກົດບັນທຶກເພື່ອສ້າງເອກະສານ.",
    placement: "top",
  },
];
